import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getProductCartApi = createAsyncThunk(
  "addProductInCart",
  async () => {
    const response = await axiosInstance.get("/merchant/getCart");
    return response.data;
  }
);

const getProductCartSlice = createSlice({
  name: "addProductInCart",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductCartApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getProductCartApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(getProductCartApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.status = "idle";
      });
  },
});

export default getProductCartSlice.reducer;
